export default "__VITE_ASSET__CLbXBnPv__"